
function Util()
{
    this.digits = ['', 'first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eighth', 'ninth', 'tenth', 'eleventh', 'twelvth', 'thirteenth', 'fourteenth', 'fifteenth', 'sixteenth', 'seventeenth', 'eighteenth', 'nineteenth'];
    this.counts = ['no', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
    this.tens = ['twent', 'thirt', 'fourt', 'fift', 'sixt', 'sevent', 'eight', 'ninet'];
    var t = this;
    this.random = function(min, max)
    {
        return Math.random() * (max - min) + min;
    };
    this.select = function(array)
	{
		return array[Math.floor(t.random(0, array.length))];
	};
	this.toUpper = function(s)
	{
		return s[0].toUpperCase() + s.substr(1);
	};
	this.swap = function(a, b)
	{
		var c = a;
		a = b;
		b = c;
    };
	this.toCount = function(n)
	{
		if(n < 20) return t.counts[n];
		var ten = t.tens[Math.floor(n / 10) - 2] + "y";
		if(n % 10 == 0) return ten;
		return ten + "-" + t.counts[n % 10];  
	};

	this.number = function(n) 
	{
		if(n < 20) return t.digits[n];
		var ten = t.tens[Math.floor(n / 10) - 2];
		if(n % 10 == 0) return ten + 'ieth';
		return ten + 'y-' + t.digits[n % 10];
	};

	this.clamp = function(v, min, max){
		if(v < min) return min;
		if(v > max) return max;
		return v;
	};
	
	this.getHour = function(time){
		return Math.floor((time % 86400) / 3600);
	};
	this.getMinute = function(time){
		return Math.floor((time % 3600) / 60);
	};
	this.getSecond = function(time){
		return time % 60;
	};

	this.rgb = function(r,g,b,a)
	{
		if(r === undefined) return "";
		if(g === undefined){
			if(r != undefined && r.r != undefined){
				return this.rgb(r.r, r.g, r.b, r.a);
			}
			g = r; b = r;
		}
		if(a === undefined) a = 1.0;
		return "rgba(" + Math.round(r*255) + "," + Math.round(g*255) + "," + Math.round(b*255) + "," + a + ")";
	};

	this.timeSince = function(t)
	{
		if(t > game.time)
			t -= (24 * 60 * 60)
		return game.time - t;
	};

	this.pulse = function(i, freq, min, max)
	{
		return min + max * (1 - 2.0 * (Math.abs(0.5 - (i % freq) / (freq - 1))));
	}

	this.HSVtoRGB = function(h, s, v)
	{
		var r, g, b, i, f, p, q, t;
		if (arguments.length === 1) {
			s = h.s, v = h.v, h = h.h;
		}
		i = Math.floor(h * 6);
		f = h * 6 - i;
		p = v * (1 - s);
		q = v * (1 - f * s);
		t = v * (1 - (1 - f) * s);
		switch (i % 6) {
			case 0: r = v, g = t, b = p; break;
			case 1: r = q, g = v, b = p; break;
			case 2: r = p, g = v, b = t; break;
			case 3: r = p, g = q, b = v; break;
			case 4: r = t, g = p, b = v; break;
			case 5: r = v, g = p, b = q; break;
		}
		return {
			r: r,
			g: g,
			b: b
		};
	}
}

let util = new Util();
export { util as default };